var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.66667H14M4.66667 10H5.33333M8 10H8.66667M4 12.6667H12C12.5304 12.6667 13.0391 12.456 13.4142 12.0809C13.7893 11.7058 14 11.1971 14 10.6667V5.33333C14 4.8029 13.7893 4.29419 13.4142 3.91912C13.0391 3.54405 12.5304 3.33333 12 3.33333H4C3.46957 3.33333 2.96086 3.54405 2.58579 3.91912C2.21071 4.29419 2 4.8029 2 5.33333V10.6667C2 11.1971 2.21071 11.7058 2.58579 12.0809C2.96086 12.456 3.46957 12.6667 4 12.6667Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardOutline);
export default __webpack_public_path__ + "static/media/CreditCardOutline.ba4ddb65bab57d3e891e1471d4fd72f6.svg";
export { ForwardRef as ReactComponent };